import React from 'react'

import { VscChevronDown, VscChevronUp } from 'react-icons/vsc'

import { SectionSubtitle } from '..'
import { questions } from '../../pages/InitialFormPage'
import { QuestionWithAnswers } from '../../pages/InitialFormPage/styles'
import { capitalizeFirstLetter } from '../../utilFunctions/transformFunc'

import {
  FormResponsesSectionContainer,
  CollapsableContainer,
  CollapsableTitle,
  CollapsableContent,
} from './styles'

const FormResponsesSection = ({
  hasForm,
  form,
}: {
  hasForm: boolean
  form?: { [key: string]: string }
}) => {
  const [isCollapsed, setIsCollapsed] = React.useState(false)

  return (
    <FormResponsesSectionContainer>
      <CollapsableContainer>
        <CollapsableTitle
          $hasForm={hasForm}
          onClick={hasForm ? () => setIsCollapsed(!isCollapsed) : undefined}
        >
          <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
            <>
              Cuestionario:{' '}
              <span style={{ color: hasForm ? '#08A8D2' : '#0A0A18' }}>
                {hasForm ? 'Realizado' : 'Incompleto'}
              </span>
            </>
          </SectionSubtitle>
          {hasForm && (
            <div onClick={() => setIsCollapsed(!isCollapsed)}>
              <p>
                Ver respuestas{' '}
                {isCollapsed ? <VscChevronUp /> : <VscChevronDown />}
              </p>
            </div>
          )}
        </CollapsableTitle>
        <CollapsableContent $isCollapsed={isCollapsed}>
          <div>
            {form &&
              Object.entries(form).map(([key, value]) => (
                <QuestionWithAnswers key={key}>
                  <p className="number">{key}</p>
                  <p className="question">
                    {questions.find((question) => question.id === key)?.text}
                  </p>

                  <p className="response">{capitalizeFirstLetter(value)}</p>
                </QuestionWithAnswers>
              ))}
          </div>
        </CollapsableContent>
      </CollapsableContainer>
    </FormResponsesSectionContainer>
  )
}

export default FormResponsesSection
